import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { SetAqControl } from 'src/app/project/shared/interfaces/set-aq-control';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';

@Component({
  selector: 'avs-set-flasher-control',
  standalone: false,
  templateUrl: './set-flasher-control.component.html',
  styleUrl: './set-flasher-control.component.css'
})
export class SetFlasherControlComponent implements OnInit, OnChanges {

  @Input() dataEndChannels!: DataEndChannel[];
  @Input() selectedAQControlStellcode?: number;
  @Input() selectedKanalId?: number;
  @Input() selectedAqChannel?: DataEndChannel;

  function: boolean = false;
  functionAsNumber: number = 0;

  /* 
    public isFunctionDropdownOpen: boolean = false;
    public functionSelect: SelectInput[] = [{ name: 'Aus', id: 0 }, { name: 'An', id: 1 }];
    public selectedFunction: SelectInput = { name: "Funktion" }; */

  constructor(private dataEndChannelService: DataEndChannelService, private alertService: AlertService) { }


  ngOnInit(): void {
    this.parseChannelState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedAqChannel'] && this.selectedAqChannel) {
      this.parseChannelState();
    }
  }

  private parseChannelState(): void {
    if (this.selectedAqChannel) {
      let doControl = this.selectedAqChannel.manualControl;
      if (doControl) {
        let parsedDoSettings = JSON.parse(doControl.settings);
        let parsedDo = parsedDoSettings.AQ;
        this.function = parsedDoSettings.AQ.Function;
        /* this.state = parsedDoSettings.DO.State; */
      } else {
      }
    }
  }

  get toggleValue(): number {
    return this.function ? 1 : 0;
  }

  onToggleChange() {
    const value = this.toggleValue;
    // z. B. this.service.updateStatus(value);
  }
  /* 
    public onFunctionItemClicked(item: SelectInput): void {
      this.isFunctionDropdownOpen = false;
      this.selectedFunction.name = item.name
      this.selectedFunction.id = item.id
      let funcId = item.id as number
  
    }
  
    public onFunctionDropdownClicked(): void {
      this.isFunctionDropdownOpen = !this.isFunctionDropdownOpen;
    } */

  createFlasherControl(): void {
    this.setFlasherManualControl()
  }

  setFlasherManualControl(): void {
    let aqControl = {
      active: true,
      code: 61,
      function: this.toggleValue,
      time: 0

    } as SetAqControl;
    this.dataEndChannelService.setAqManualControl(Number(this.selectedAqChannel?.id), aqControl).subscribe(resp => {
      this.alertService.alert('AQ Control wurde erstellt', AlertTypes.success);
    })
  }


  setFlasherManualControlImageOff(): void {
    let aqControl = {
      active: true,
      code: 61,
      function: 0,
      time: 0
    } as SetAqControl;
    this.dataEndChannelService.setAqManualControl(Number(this.selectedAqChannel?.id), aqControl).subscribe(resp => {
      this.alertService.alert('AQ Control wurde ausgeschaltet', AlertTypes.success);
    })
  }


  turnFlasherControlOff(): void {
    let dataEndChannelId = Number(this.selectedAqChannel?.id)
    let aqControl = {
      active: false,
      code: 61,
      function: 0,
      time: 0
    } as SetAqControl;
    this.dataEndChannelService.setAqManualControl(dataEndChannelId, aqControl).subscribe(resp => {
      this.alertService.alert('AQ Control wurde ausgeschaltet', AlertTypes.success);
    })
  }
}